<template>
  <div class="flex flex-wrap mb-2">
    <div ref="budgetType" class="d2-panel-main bg-white rounded-xl space-y-6">
      <div>
        <span class="text-red-500">*</span>
        <span class="text-gray-700 align-middle">{{lang['components']['Event']['BudgetType']['title']}}</span>
        <i
          class="pi pi-exclamation-circle align-middle text-gray-300 ml-2"
          v-tooltip.top="lang['components']['Event']['BudgetType']['title_info']"
        ></i>
      </div>
      <div class="space-y-4">
        <div class="flex items-center">
          <input
            :disabled="editPageType"
            type="radio"
            id="budget_daily"
            value="daily"
            v-model="selectedBudgetType"
            class="w-4 h-4 text-blue-600 focus:ring-blue-500"
          />
          <label for="budget_daily" class="ml-2 text-gray-700 cursor-pointer">
            {{lang['components']['Event']['BudgetType']['daily_budget']}}
          </label>
        </div>
        <div class="flex items-center">
          <input
            :disabled="editPageType"
            type="radio"
            id="budget_lifetime"
            value="lifetime"
            v-model="selectedBudgetType"
            class="w-4 h-4 text-blue-600 focus:ring-blue-500"
          />
          <label for="budget_lifetime" class="ml-2 text-gray-700 cursor-pointer">
            {{lang['components']['Event']['BudgetType']['lifetime_budget']}}
          </label>
        </div>
      </div>
      <div
        class="flex items-start rounded-lg border px-4 py-3 text-sm"
        :class="selectedBudgetType === 'lifetime'
          ? 'border-yellow-200 bg-yellow-50 text-yellow-800'
          : 'border-blue-200 bg-blue-50 text-blue-700'"
      >
        <i class="pi pi-info-circle mr-2 mt-0.5"></i>
        <span>{{ selectedBudgetType === 'lifetime'
          ? lang['components']['Event']['BudgetType']['objective_tip_lifetime']
          : lang['components']['Event']['BudgetType']['objective_tip_daily'] }}</span>
      </div>
    </div>
    <div class="d2-panel-tips rounded-xl space-y-2 px-4"></div>
  </div>
</template>

<script>
export default {
  name: "BudgetType",
  components: {},
  props: {
    editPage: {
      type: Boolean
    },
    viewDatalist: {
      type: String,
      default: 'daily'
    },
    lang: {
      type: Object
    },
  },
  data() {
    return {
      selectedBudgetType: 'daily'
    };
  },
  watch:{
    'viewDatalist':function(v){
      this.selectedBudgetType = v || 'daily'
    },
    selectedBudgetType (value){
      this.$emit('childBudgetType', value);
    }
  },
  computed: {
    editPageType: {
      get: function () {
        return this.editPage
      },
      set: function (value) {
        this.$emit('update:editPageType', value)
      },
    },
  },
  mounted() {
    if (this.viewDatalist) {
      this.selectedBudgetType = this.viewDatalist;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
